// src/pages/admin/Services.jsx
import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import AdminSidebar from '../../components/admin/AdminSidebar';
import ServiceManager from '../../components/admin/ServiceManager';

const Services = () => {
  const [searchParams] = useSearchParams();
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    const editId = searchParams.get('edit');
    if (editId) {
      setEditingId(editId);
    }
  }, [searchParams]);

  return (
    <div className="flex min-h-screen bg-gray-100">
      <AdminSidebar />
      
      <div className="flex-1 p-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-800">Manage Services</h1>
          <p className="text-gray-600">Add, edit, and organize company services</p>
        </div>

        <ServiceManager editingId={editingId} />
      </div>
    </div>
  );
};

export default Services;




// src/pages/user/Services.jsx
// import React, { useState, useEffect } from 'react';
// import ServiceCard from '../../components/user/ServiceCard';
// import { getServices } from '../../utils/api';

// const Services = () => {
//     const [services, setServices] = useState([]);
//     const [filteredServices, setFilteredServices] = useState([]);
//     const [categories, setCategories] = useState(['all']);
//     const [activeCategory, setActiveCategory] = useState('all');
//     const [loading, setLoading] = useState(true);

//     useEffect(() => {
//         loadServices();
//     }, []);

//     useEffect(() => {
//         filterServices();
//     }, [activeCategory, services]);

//     const loadServices = async () => {
//         try {
//             setLoading(true);
//             const data = await getServices();
            
//             // Handle different response structures
//             let servicesArray = [];
            
//             if (Array.isArray(data)) {
//                 servicesArray = data;
//             } else if (data && data.data && Array.isArray(data.data.data)) {
//                 servicesArray = data.data.data;
//             } else if (data && data.data && Array.isArray(data.data)) {
//                 servicesArray = data.data;
//             } else if (data && Array.isArray(data.services)) {
//                 servicesArray = data.services;
//             } else {
//                 console.error('Unexpected data structure:', data);
//                 servicesArray = [];
//             }
            
//             // Filter only active services for user display
//             const activeServices = servicesArray.filter(service => 
//                 service.is_active !== false
//             );
            
//             setServices(activeServices);
            
//             // Extract unique categories from services
//             const uniqueCategories = extractUniqueCategories(activeServices);
//             setCategories(['all', ...uniqueCategories]);
            
//         } catch (error) {
//             console.error('Error loading services:', error);
//             setServices([]);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const filterServices = () => {
//         if (activeCategory === 'all') {
//             setFilteredServices(services);
//         } else {
//             const filtered = services.filter(service => {
//                 if (!service.category) return false;
                
//                 // Normalize both strings for comparison
//                 const serviceCategory = service.category.trim().toLowerCase();
//                 const activeCategoryLower = activeCategory.toLowerCase();
                
//                 // Check for exact match or contains
//                 return serviceCategory === activeCategoryLower || 
//                        serviceCategory.includes(activeCategoryLower) ||
//                        activeCategoryLower.includes(serviceCategory);
//             });
            
//             console.log('Filtering by:', activeCategory);
//             console.log('Filtered results:', filtered);
//             console.log('All services:', services.map(s => ({ 
//                 title: s.title, 
//                 category: s.category 
//             })));
            
//             setFilteredServices(filtered);
//         }
//     };

//     const extractUniqueCategories = (servicesList) => {
//         if (!Array.isArray(servicesList)) return [];
        
//         // Get all non-empty categories, trim whitespace
//         const categoriesMap = new Map();
        
//         servicesList.forEach(service => {
//             if (service.category && typeof service.category === 'string') {
//                 const trimmedCategory = service.category.trim();
//                 if (trimmedCategory.length > 0) {
//                     // Use lowercase as key to avoid duplicates with different cases
//                     const key = trimmedCategory.toLowerCase();
//                     if (!categoriesMap.has(key)) {
//                         // Store the original formatted version
//                         categoriesMap.set(key, trimmedCategory);
//                     }
//                 }
//             }
//         });
        
//         // Convert Map values to array and sort alphabetically
//         return Array.from(categoriesMap.values()).sort((a, b) => 
//             a.localeCompare(b, undefined, { sensitivity: 'base' })
//         );
//     };

//     const formatCategoryName = (category) => {
//         if (category === 'all') return 'All Services';
        
//         // Convert to proper case
//         return category
//             .toLowerCase()
//             .split(' ')
//             .map(word => {
//                 if (word.length > 0) {
//                     return word.charAt(0).toUpperCase() + word.slice(1);
//                 }
//                 return word;
//             })
//             .join(' ');
//     };

//     // Helper function to normalize category names for filtering
//     const normalizeCategory = (category) => {
//         if (!category) return '';
//         return category.trim().toLowerCase().replace(/\s+/g, ' ');
//     };

//     // Get service count for each category
//     const getCategoryCount = (category) => {
//         if (category === 'all') return services.length;
        
//         const normalizedCategory = normalizeCategory(category);
//         return services.filter(service => {
//             const serviceCategory = normalizeCategory(service.category);
//             return serviceCategory.includes(normalizedCategory) || 
//                    normalizedCategory.includes(serviceCategory);
//         }).length;
//     };

//     if (loading) {
//         return (
//             <div className="min-h-screen flex items-center justify-center">
//                 <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
//             </div>
//         );
//     }

//     return (
//         <div className="min-h-screen bg-gray-50">
//             {/* Hero Section */}
//             <section className="bg-gradient-to-r from-blue-900 to-gray-900 text-white py-20">
//                 <div className="container mx-auto px-4">
//                     <div className="max-w-3xl">
//                         <h1 className="text-5xl font-bold mb-6">Our Services</h1>
//                         <p className="text-xl text-blue-100">
//                             Comprehensive engineering solutions across multiple sectors in Zambia
//                         </p>
//                     </div>
//                 </div>
//             </section>

//             <div className="container mx-auto px-4 py-8">
//                 <h1 className="text-4xl font-bold text-center mb-8">Our Services</h1>
                
//                 {/* Dynamic Category Filter */}
//                 <div className="mb-8">
//                     <h2 className="text-xl font-semibold text-gray-700 text-center mb-4">
//                         Browse by Category
//                     </h2>
//                     <div className="flex flex-wrap justify-center gap-3 mb-8">
//                         {categories.map(category => {
//                             const count = getCategoryCount(category);
//                             const isActive = activeCategory === (category === 'all' ? 'all' : normalizeCategory(category));
                            
//                             return (
//                                 <button
//                                     key={category}
//                                     onClick={() => setActiveCategory(category === 'all' ? 'all' : normalizeCategory(category))}
//                                     className={`px-5 py-3 rounded-lg capitalize transition-all duration-200 flex items-center gap-2 ${
//                                         isActive
//                                             ? 'bg-blue-600 text-white shadow-lg transform scale-105' 
//                                             : 'bg-white text-gray-700 border hover:bg-gray-50 hover:shadow-md'
//                                     }`}
//                                 >
//                                     <span>{formatCategoryName(category)}</span>
//                                     <span className={`text-xs px-2 py-0.5 rounded-full ${
//                                         isActive 
//                                             ? 'bg-blue-500 text-white' 
//                                             : 'bg-gray-200 text-gray-600'
//                                     }`}>
//                                         {count}
//                                     </span>
//                                 </button>
//                             );
//                         })}
//                     </div>
                    
//                     {/* Active category indicator */}
//                     <div className="text-center mb-6">
//                         <span className="inline-block px-4 py-1 bg-blue-100 text-blue-800 rounded-full text-sm font-medium">
//                             {activeCategory === 'all' 
//                                 ? `Showing all ${services.length} services`
//                                 : `Showing ${filteredServices.length} service${filteredServices.length !== 1 ? 's' : ''} in "${formatCategoryName(activeCategory)}"`
//                             }
//                         </span>
//                     </div>
//                 </div>

//                 {/* Services Grid */}
//                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//                     {filteredServices.map(service => (
//                         <ServiceCard key={service.id} service={service} />
//                     ))}
//                 </div>

//                 {filteredServices.length === 0 && !loading && (
//                     <div className="text-center py-12">
//                         <div className="max-w-md mx-auto">
//                             <div className="text-gray-400 mb-4">
//                                 <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//                                 </svg>
//                             </div>
//                             <p className="text-gray-500 text-lg mb-2">No services found</p>
//                             <p className="text-gray-400 mb-4">
//                                 {activeCategory !== 'all' 
//                                     ? `No services available in "${formatCategoryName(activeCategory)}" category`
//                                     : 'No services available at the moment'
//                                 }
//                             </p>
//                             {activeCategory !== 'all' && (
//                                 <button
//                                     onClick={() => setActiveCategory('all')}
//                                     className="text-blue-600 hover:text-blue-800 font-medium px-4 py-2 border border-blue-200 rounded-lg hover:bg-blue-50 transition-colors duration-200"
//                                 >
//                                     View all services →
//                                 </button>
//                             )}
//                         </div>
//                     </div>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default Services;